// NZSC-2995: cow 무한발급 의심 (어드민 전용)
// BE: GET /v1/admin/cow/infinite-suspect (NZSC-2996)
// 모닝 브리핑(NZSC-2961/2977/2998)과 별개로, 운영자가 어드민에서 list/필터/상세이동.
import api from "../../utils/api";

export const state = {
  _suspectList: [], // today list (with yesterdayIssuanceCount, changeFromYesterday)
  _suspectResolved: [], // 어제 list에 있었지만 오늘 사라진 = 자동 전환된 케이스
  _suspectSummary: { same: 0, increased: 0, new: 0, resolved: 0 },
  _suspectPage: { total: 0, page: 1, limit: 50 },
};

export const mutations = {
  setSuspectResult(state, data) {
    state._suspectList = data.cases || [];
    state._suspectResolved = data.resolved || [];
    state._suspectSummary = data.summary || { same: 0, increased: 0, new: 0, resolved: 0 };
    state._suspectPage = {
      total: data.total || 0,
      page: data.page || 1,
      limit: data.limit || 50,
    };
  },
  clearSuspectResult(state) {
    state._suspectList = [];
    state._suspectResolved = [];
    state._suspectSummary = { same: 0, increased: 0, new: 0, resolved: 0 };
    state._suspectPage = { total: 0, page: 1, limit: 50 };
  },
};

export const actions = {
  async acGetCowSuspectList({ commit }, params) {
    const url = `/api/v1/admin/cow/infinite-suspect`;
    try {
      const res = await api.get(url, { params });
      // BE는 raw object 반환 (statusCode wrapper 없음, NZSC-2996 internal 패턴 동일)
      commit("setSuspectResult", res.data);
      return res.data;
    } catch (e) {
      console.error("cow 의심 목록 조회 실패", e);
      commit("clearSuspectResult");
      return null;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
